//@flow
import type { ProductType } from 'common/enums/Product';
import { type AppState } from 'common/redux/reducers';

const extractProperty = (state, product: ProductType, key: string) => {
    if (state && state.uiSwitcher) {
        const stateForProduct = state.uiSwitcher[product];
        if (!stateForProduct) {
            return null;
        }
        return stateForProduct[key];
    }
    return null;
};

const extractBooleanProperty = (
    state,
    product: ProductType,
    key: string
): boolean => {
    const value = extractProperty(state, product, key);
    return value ? true : false;
};

export const getV2PopupState = (
    state: Object,
    product: ProductType
): string | null => {
    return extractProperty(state, product, 'v2PopupState');
};

export const getV2LastNotified = (
    state: Object,
    product: ProductType
): string | null => {
    return extractProperty(state, product, 'v2LastNotified');
};

export const isReadyToShowV2Popup = (
    state: Object,
    product: ProductType
): boolean => {
    return extractBooleanProperty(state, product, 'isReadyToShowV2Popup');
};

export const getUpgradeLater = (
    state: Object,
    product: ProductType
): string | null => {
    return extractProperty(state, product, 'upgradeLater');
};

export const getIsV2PopupAcknowledged = (
    state: AppState,
    product: ProductType
): boolean => {
    return extractBooleanProperty(state, product, 'isV2PopupAcknowledged');
};

export const getIsV1PopupAcknowledged = (
    state: AppState,
    product: ProductType
): boolean => {
    return extractBooleanProperty(state, product, 'isV1PopupAcknowledged');
};

export const getIsAccessWalkthroughAcknowledged = (
    state: AppState,
    product: ProductType
): boolean => {
    return extractBooleanProperty(
        state,
        product,
        'isAccessWalkthroughAcknowledged'
    );
};
